export interface ScheduledShift {
  id: string; // shiftId
  contractorId: string;
  facilityId: string;
  date: string;
  startTime: string;
  endTime: string;
  scopeOfPractice: string;
  hours: number;
}
